<template>
  <div class="pages" :style="{ height: fixedHeight + 'px' }">
    <!-- 左侧表单 -->
    <div class="pageLeft">
      <div class="titleView">
        <div class="line"></div>
        <div class="titleName">商品配置</div>
      </div>
      <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" id="addHuodong" size="small">
        <el-form-item label="名称" prop="title" class="w300" label-width="100px">
          <el-input v-model="ruleForm.title" placeholder="请输入名称" size="small"></el-input>
        </el-form-item>
        <el-form-item label="编号" prop="performanceNum" class="w300" label-width="100px">
          <el-input v-model="ruleForm.performanceNum" placeholder="请输入编号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="优先级" prop="priority" class="w300" label-width="100px">
          <el-input v-model="ruleForm.priority" placeholder="请输入优先级" size="small"></el-input>
        </el-form-item>
       
        <div class="titleView">
        <div class="line"></div>
        <div class="titleName">提成配置</div>
      </div>
        <el-form-item label="提成配置" label-width="120px" style="margin-left: -120px">
          <div v-for="(item, key) in ruleForm.performanceConfig" :key="key">
            <span>
              提成比例
             <el-input size="mini" style="width: 120px" v-model="item.ratio" @input="(v)=>(aaa=v.replace(/[^\d.]/g,''))"  placeholder="请输入比例"></el-input>
           </span>
            <span>
              提成区间
              <el-input size="mini" style="width: 120px" v-model="item.saleMinAmount" placeholder="请输入最小"></el-input>
              -
              <el-input size="mini" style="width: 120px" v-model="item.saleMaxAmount" placeholder="请输入最大"></el-input>
            </span>
            <el-button style="margin-left: 5px" type="text"
              @click="addweightobj(ruleForm.performanceConfig)">新建</el-button>
            <el-button style="margin-left: 5px" type="text"
              @click="deletWeightobj(ruleForm.performanceConfig, key)">删除</el-button>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="remark" label-width="100px">
          <el-input type="textarea" v-model="ruleForm.remark" resize="none" style="width: 600px" rows="4"
            size="small"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <!-- 右侧添加商品和赠品 -->
    <div class="pageRight">
      <div class="pageRightView">
        <!-- 添加商品 -->
        <div class="shopView" style="margin-bottom: 20px">
          <div class="titleView">
            <div class="line"></div>
            <div class="titleName">添加产品</div>
          </div>
          <!-- 选择商品 -->
          <div>
            <div style="margin: 10px 0; display: flex">
              <el-button type="warning" size="small" @click="handleSelectGoodsClick(1)">选择商品</el-button>
              <el-button type="warning" size="small" @click="handleBatchShopDeleteClick()">批量删除</el-button>
            </div>
            <el-table :data="shopTable" border style="width: 100%" @selection-change="handleSelectShopChange">
              <el-table-column type="selection" width="55" align="center">
              </el-table-column>
              <el-table-column prop="goodsName" label="名称" align="center">
              </el-table-column>
              <el-table-column fixed="right" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="small" @click="handelDeleteGoodsClick(1, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="pageRightBtn">
        <el-button @click="handleBackClick" size="small">返回</el-button>
        <el-button type="warning" @click="handelSubmitClick" v-if="routerType != 1" size="small">提交配置</el-button>
      </div>
    </div>
    <!-- 添加商品弹框 -->
    <div v-if="dialogAddShop_state">
      <dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state"
        :selectType.sync="selectType" @submit="selectShop" :tree.sync="tree"></dialogAddShop>
    </div>
  </div>
</template>

<script>
import {
  firstcatgory,
  addActive,
  updateActive,
} from "@/api/purchaseApi.js";
import dialogAddShop from "../../components/dialog_addShop.vue";
import { stringify } from "querystring";
export default {
  components: {
    dialogAddShop,
  },
  data() {
    return {
      fixedHeight: "",
      disabled: false,
      shopTable:[],
      activitInfo: this.$route.query.activitInfo,
      dialogAddShop_state:false,
      routerType: this.$route.query.type, // 1查看 2编辑
      ruleForm: {
        title:'',
        remark:'',
        priority:'',
        performanceNum:'',
        goodsList:[],
        performanceConfig:[
          {
          saleMinAmount: "",
          saleMaxAmount: "",
          ratio: "",
          }
        ],
      }
    };
  },
  mounted() {
    this.fixedHeight = document.documentElement.clientHeight - 86;
    //详情跳转回显数据
    if (this.activitInfo != undefined) {
      console.log("详情", JSON.parse(this.activitInfo));
      let info = JSON.parse(this.activitInfo);
      let ruleForm = this.ruleForm;
      console.log(info,'info');
      // ---------------公共数据回显
      ruleForm.performanceConfig = info.performanceConfig; //活动类型
      ruleForm.title = info.title; //活动名称
      ruleForm.remark = info.remark; //活动权重
      ruleForm.priority = info.priority; //用户类型
      ruleForm.performanceNum = info.performanceNum; //是否新人专享
      this.shopTable = info.goodsList; //是否新人专享

    }
  },
  methods: {
    handleSelectShopChange(val) {
      this.selectShopTable = val;
    },
    addweightobj(item) {
      console.log(item,'arr');
      item.push({
          saleMinAmount: "",
          saleMaxAmount: "",
          ratio: "",
       
      });
    },
    deletWeightobj(item, index) {
      item.splice(index, 1);
    },
    //提交活动
    handelSubmitClick() {
      console.log("添加商品列表", this.shopTable);
      let ruleForm = this.ruleForm;
      // -----------------------验证
      if (ruleForm.title == "") {
        this.$message({
          type: "error",
          message: "请输入配置名称",
        });
        return;
      }
      if (ruleForm.performanceNum =='') {
        this.$message({
          type: "error",
          message: "请添加编号",
        });
        return;
      }
      if (ruleForm.priority =='') {
        this.$message({
          type: "error",
          message: "请添加优先级",
        });
        return;
      }
      if (ruleForm.goodsList.length <0) {
        this.$message({
          type: "error",
          message: "请添加商品",
        });
        return;
      }
      if (ruleForm.remark == "") {
        this.$message({
          type: "error",
          message: "请填写说明",
        });
        return;
      }

      let params = {
        title: ruleForm.title, //活动名称
        remark:ruleForm.remark,
        priority:ruleForm.priority,
        performanceNum:ruleForm.performanceNum,
        goodsList:this.shopTable,
        performanceConfig:ruleForm.performanceConfig
      };
      
      if (this.routerType != 2) {
        console.log("创建params", params);
        this.$http
        .post(process.env.VUE_APP_zichan + "/api/Performance/AddGoodsPerformance", params)
        .then((res) => {
          if (res.code == 0) {
            console.log("返回", res);
            this.$message({
              type: "success",
              message: "创建成功",
            });
            this.$router.back();
          }
        });
      } else {
        let info = JSON.parse(this.activitInfo);
        params.id = info.id;

        this.$http
        .post(process.env.VUE_APP_zichan + "/api/Performance/UpdateGoodsPerformance", params)
        .then((res) => {
          if (res.code == 0) {
            console.log("返回", res);
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.$router.back();
          }
        });
      }
      console.log("参数vparams", params);
    },
    //商品列表批量删除
    handleBatchShopDeleteClick() {
      if (this.selectShopTable.length == 0) {
        this.$message({
          type: "error",
          message: "请选中产品",
        });
        return;
      }
      for (let i = 0; i < this.selectShopTable.length; i++) {
        for (let j = 0; j < this.shopTable.length; j++) {
          if (this.selectShopTable[i].param_type_id == 0) {
            //删除商品
            if (
              this.selectShopTable[i].goods_id == this.shopTable[j].goods_id &&
              this.selectShopTable[i].skus == this.shopTable[j].skus
            ) {
              this.shopTable.splice(j, 1);
            }
          } else {
            if (
              this.selectShopTable[i].goods_id == this.shopTable[j].goods_id
            ) {
              this.shopTable.splice(j, 1);
            }
          }
        }
      }
    },
    //切换添加产品 初始化
    handelShopTypeClick() {
      this.selectBrand = [];
      this.selectCategory = [];
      this.shopTable = [];
      this.selectPet = [];
      this.chinNo = "";
      this.optionalNum = 0;
      this.brandValue = "";
    },
    //返回
    handleBackClick() {
      this.$confirm("是否退出当前页面？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.back();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //删除商品
    handelDeleteGoodsClick(type, index) {
      console.log(type, index);
      if (type == 1) {
        //删除商品
        this.shopTable.splice(index, 1);
        this.$message({
          type: "error",
          message: "已删除",
        });
      }
    },
    //已选中商品
    selectShop(val) {
      console.log("已选中商品11111", val);
      let shopObj = {
        param_type_id: val.goodsType + "",
      };
      console.log("已选中商品", shopObj);
      //添加商品
        if (val.goodsType == 0) {
          //商品类目
          shopObj.param_type_name = "商品"; //类型名字
          shopObj.goodsId = val.goodsItem.goodsId; //商品id
          shopObj.goodsName = val.goodsItem.title; //商品名字
        } 
        this.shopTable.push(shopObj);
        console.log("商品列表", this.shopTable);
        this.$message({
          type: "success",
          message: "已添加",
        });
      
    },
    //选择商品
    handleSelectGoodsClick(type) {
        console.log("添加产品");
        this.dialogAddShop_state = true;
        this.selectType = type;
        this.tree = [
          {
            //显示所需要类目
            id: "602f1e89c904d9db7ccf3c03", //商品
          },
        ];
     
    },

    //获取一级分类列表
    getFirstcatgory() {
      let params = {
        category: "商品,虚拟,活体,医疗,生活服务,医疗服务,套餐",
      };
      firstcatgory(params).then((res) => {                                   
        if (res.code == 0) {
          // console.log('分类列表',res)
          this.firstcatgoryData = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background: #fff;
  padding: 20px 20px 0 20px;
  display: flex;

  .titleView {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: solid 1px #f5f5f5;

    .line {
      width: 2px;
      height: 15px;
      background: #1890ff;
      margin-right: 10px;
    }

    .titleName {
      font-size: 16px;
      color: #2a2a2a;
      font-weight: bold;
    }
  }

  .pageLeft {
    padding-right: 20px;
    border-right: solid 1px rgba(0, 0, 0, 0.1);
    padding-bottom: 20px;
    overflow-y: scroll;
  }

  .pageLeft::-webkit-scrollbar {
    display: none;
  }

  .pageRight {
    flex: 1;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;

    .pageRightView {
      flex: 1;
      overflow-y: auto;

      .comClass {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin: 10px 0;

        .comTitle {
          margin-right: 10px;
        }
      }

      .comView {
        width: 94%;
        min-height: 120px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        padding: 10px 10px 0 10px;

        .comItem {
          margin-right: 6px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          padding: 0 6px 0 10px;
          background: #e6f7ff;
          border: 1px solid #91d5ff;
          line-height: 22px;
          font-size: 12px;
          color: #1890ff;
          display: inline-block;
          border-radius: 2px;

          span:nth-of-type(1) {
            margin-right: 10px;
          }
        }
      }
    }

    .pageRightBtn {
      height: 90px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .pageRight::-webkit-scrollbar {
    display: none;
  }

  .mt20 {
    margin-top: 20px;
  }

  .w300 {
    width: 300px;
  }

  .w600 {
    width: 500px;
  }

  .reductionTabs {
    display: flex;
    align-items: center;
    margin-left: 100px;
    font-size: 14px;
    margin-bottom: 22px;

    div {
      width: 50px;
      line-height: 24px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      text-align: center;
      border-radius: 2px;
    }

    div:nth-of-type(1) {
      margin-right: 20px;
    }

    .reductionActive {
      background: #f5882a;
      color: #fff;
    }
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
